import request from './request'
import { request as http } from '@/api/request';
import store from '@/store';
import axios from 'axios';
const CancelToken = axios.CancelToken;

export function getJobNumber (params) {
  return request.get('/largescreen/job/getJobNumber', params).then(res => res);
}
export function getAllowanceAmount (params) {
  return request.get('/largescreen/job/getAllowanceAmount', params).then(res => res);
}
export function getJobListByPlotId (params) {

  return request.get('/largescreen/job/getJobListByPlotId', params).then(res => res);
}
export function getPlotList (params) {
  return request.get('/largescreen/job/getPlotList', params).then(res => res);
}
export function getAllowanceByJobType (params) {
  return request.get('/largescreen/job/getAllowanceByJobType', params).then(res => res);
}
export function getAllowanceByArea (params) {
  return request.get('/largescreen/job/getAllowanceByArea', params).then(res => res);
}
export function getJobArea (params) {
  return request.get('/largescreen/job/getJobArea', params).then(res => res);
}
export function getAvgJobArea (params) {
  return request.get('/largescreen/job/getAvgJobArea', params).then(res => res);
}
export function getJobType (params) {
  return request.get('/largescreen/job/getJobType', params).then(res => res);
}
export function getplotFxSelectOne (params) {
  return request.get('/plotFx/select/one/1533413672402165760', params).then(res => res);
}
// 获取所有地块
export function getplotFxSelect (params) {
  return request.post('/plotFx/select/list/by-model', params).then(res => res);
}

// 获取各区域统计信息
export function getJobAreaCount (params) {
  return request.get('/largescreen/job/getJobAreaCount', params).then(res => res);
}

// 查询当年、去年累计作业量及同比完成率
export function getCurrYearJobAreaSum (params) {
  return request.get('/largescreen/job/getCurrYearJobAreaSum', params).then(res => res);
}

// 各作业类型作业量
export function getAreaSumByType (params) {
  return request.get('/largescreen/job/getAreaSumByType', params).then(res => res);
}

// 各作业量统计
export function getWorkAmountByType (params) {
  return request.get('/largescreen/job/getWorkAmountByType', params).then(res => res);
}

// 各作业类型作业量同比/环比
export function getRatioByType (params) {
  return request.get('/largescreen/job/getRatioByType', params).then(res => res);
}

// 单台农机平均作业量统计
export function getSingleAvgWorkAmountByType (params) {
  return request.get('/largescreen/job/getSingleAvgWorkAmountByType', params).then(res => res);
}

// 查询乡镇列表
export function getAreaList (batchNo) {
  return request.get('/largescreen/job/getAreaList/'+batchNo, {}).then(res => res);
}

// 查询机收面积年度类型列表
export function getAreaSummaryTypeList (params) {
  return request.get('/largescreen/job/getAreaSummaryTypeList', params).then(res => res);
}

// 获取累计作业时长（小时）
export function getJobTotalTime (params) {
  return request.get('/largescreen/job/getJobTotalTime', params).then(res => res);
}

// 获取实时作业数据
export function getRealTimeJobFx (params) {
  return request.get('/largescreen/job/getRealTimeJobFx', params).then(res => res);
}

// 区域点位维护-根据父级ID查询下级区域列表
export function getAreaLonAndLat(parentId) {
  let Cancel = () => {};
  let promise = new Promise((resolve, reject) => {
    const url = '../system/area/maintain/getAreaListByParentId/' + parentId;
    http({ url })
      .then((res) => {
        let points = (res || []).map((v) => {
          return {
            areaName: v.areaName,
            areaId: v.areaId,
            // lon: v.lon, // 原始点
            // lat: v.lat,
            lon: v.longitude, // 修正后的点
            lat: v.latitude,
          };
        });
        resolve(points);
      })
      .catch((res) => {
        reject(res);
      });
  });
  promise.cancel = Cancel;
  return promise;
}

// 全县三夏机收完成进度 // 全县三秋机收完成进度
export function seasonProgress(data, headers = {}) {
  let Cancel = () => {};
  let promise = new Promise((resolve, reject) => {
    const url = '/largeScreen/aidispatch/getProgressList?_usage=作业进度中的完成度';
    const params = {
      machineryType: store.getters.getMachineryType || 0, // 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械
      ...data,
      _unpack: true, // 不将 rss.data 变成 data
    };
    http({
      method: 'get',
      url,
      params,
      headers: {
        cancelToken: new CancelToken(function (cancel) {
          Cancel = cancel;
        }),
        ...headers,
      },
    })
      .then((res) => {
        const list = ((res && res.data) || []).map((v) => {
          // v.warnCount = Math.floor(Math.random() * 100) % 2;
          // v.plantingArea = (Math.random() * 100).toFixed(0);
          // v.progress = (Math.random() * 100).toFixed(1);
          // v.completedArea = (v.plantingArea * v.progress) / 100;
          // v.areaName = v.areaName + v.warnCount;
          return {
            ...v,
            warning: v.warnCount && v.warnCount > 0 ? true : false, // 预警数量，当前区域有预警则数量>0
            areaName: v.areaName && v.areaName, // 区域名称
            plantingArea: v.plantingArea || 0, // 种植面积
            completedArea: v.completedArea || 0, // 已完成作业面积
            progress: v.progress || 0, // 完成进度
          };
        });
        resolve(list);
      })
      .catch((res) => {
        reject(res);
      });
  });
  promise.cancel = Cancel;
  return promise;
}

export function seasonProgressWithCoordinates(data, headers) {
  let Cancel = () => {};
  let promise = new Promise((resolve, reject) => {
    getAreaLonAndLat(data && data.createAreaCode)
      .then((res) => {
        const coordinates = res || [];
        // res: [{"areaName": "城关镇","areaId": "410928100","lon": "115.012937","lat": "35.713689"}]
        seasonProgress(data, headers)
          .then((res) => {
            let data = {};
            const progress = res || [];
            progress.forEach(item => {
              const p = coordinates.find(v => v.areaId == item.areaCode);
              if (p) {
                const lnglat = `${p.lon}, ${p.lat}`;
                data[lnglat] = item;
              } else {
                console.warn('找不到这个地区的经纬度', item);
              }
            });
            resolve(data);
          })
          .catch((res) => {
            reject(res);
          });
      })
      .catch((res) => {
        reject(res);
      });
  });
  promise.cancel = Cancel;
  return promise;
}
